import { XMarkIcon } from "@heroicons/react/24/solid";
import { useTranslation } from "react-i18next";
import SectionLoader from "../sharedComponents/Loading/SectionLoader";

const ContactDetailsModal = ({ isOpen, onClose, contact }) => {
    const { t } = useTranslation();

    return (
        <div
            className={`fixed inset-0 z-[999] flex items-center justify-center transition-all duration-300 ${isOpen ? "visible" : "invisible"
                }`}
        >
            {/* Overlay */}
            <div
                onClick={onClose}
                className={`absolute inset-0 bg-black/60 backdrop-blur-sm transition-opacity duration-300 ${isOpen ? "opacity-100" : "opacity-0"
                    }`}
            />

            {/* Modal */}
            <div
                className={`relative z-10 w-full max-w-lg mx-4 p-6 rounded-2xl bg-white dark:bg-bg-dark-secondary shadow-xl transform transition-all duration-300 ${isOpen ? "opacity-100 scale-100" : "opacity-0 scale-95"
                    }`}
            >
                {!contact ? (
                    <SectionLoader />
                ) : (
                    <>
                        {/* Header */}
                        <div className="flex items-center justify-between mb-4">
                            <h2 className="text-xl font-semibold text-black dark:text-white">
                                {t("contacts.details")}
                            </h2>
                            <button onClick={onClose}>
                                <XMarkIcon className="w-6 h-6 text-gray-400 hover:text-black dark:hover:text-white" />
                            </button>
                        </div>

                        {/* Info */}
                        <div className="space-y-3 text-sm">

                            <div>
                                <span className="font-semibold">
                                    {t("contacts.fullName")}:
                                </span>{" "}
                                {contact.full_name}
                            </div>

                            <div>
                                <span className="font-semibold">
                                    {t("contacts.email")}:
                                </span>{" "}
                                {contact.email}
                            </div>

                            <div>
                                <span className="font-semibold">
                                    {t("contacts.phone")}:
                                </span>{" "}
                                {contact.phone}
                            </div>

                            <div>
                                <span className="font-semibold">
                                    {t("contacts.message")}:
                                </span>
                                <p className="p-3 mt-1 whitespace-pre-wrap bg-gray-100 rounded-lg dark:bg-bg-dark-primary">
                                    {contact.additional_notes}
                                </p>
                            </div>

                            <div className="text-xs text-gray-400">
                                {t("contacts.date")}:{" "}
                                {new Date(contact.createdAt).toLocaleString()}
                            </div>

                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default ContactDetailsModal;